'use client';
import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import AppLogo from '@/components/ui/AppLogo';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function AuthPageClient() {
  const [tab, setTab] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen bg-background flex">
      {/* Left Brand Panel — hidden on mobile */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary flex-col items-center justify-center p-12 relative overflow-hidden">
        {/* Decorative circles */}
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-white/5 translate-y-1/2 -translate-x-1/2" />
        <div className="absolute top-1/2 right-8 w-32 h-32 rounded-full bg-accent/20" />

        <div className="relative z-10 text-center max-w-sm">
          <div className="flex items-center justify-center gap-3 mb-8">
            <AppLogo size={52} />
            <span className="text-4xl font-extrabold text-white tracking-tight">Nongki</span>
          </div>

          <h2 className="text-2xl font-800 text-white leading-tight mb-4">
            Temukan tempat nongkrong terbaik di Malang
          </h2>
          <p className="text-white/70 text-sm leading-relaxed mb-8">
            500+ coffeeshop, review jujur dari komunitas, dan fitur Nongkrong Bareng buat kamu yang mau cari teman nongkrong!
          </p>

          {/* Feature Pills */}
          <div className="flex flex-col gap-3">
            {[
              { emoji: '☕', text: '500+ coffeeshop di Malang' },
              { emoji: '📸', text: 'Review & foto dari komunitas' },
              { emoji: '🧑‍🤝‍🧑', text: 'Nongkrong Bareng bersama teman baru' },
              { emoji: '🔖', text: 'Simpan tempat favorit ke koleksi' },
            ]?.map((f, i) => (
              <div key={`feat-${i}`} className="flex items-center gap-3 bg-white/10 rounded-xl px-4 py-3 text-left">
                <span className="text-xl">{f?.emoji}</span>
                <span className="text-sm text-white/90 font-500">{f?.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Form Panel */}
      <div className="w-full lg:w-1/2 flex flex-col min-h-screen">
        {/* Mobile header */}
        <div className="lg:hidden flex items-center justify-between px-5 pt-6 pb-4">
          <Link href="/" className="flex items-center gap-2 text-sm font-600 text-muted-foreground hover:text-primary transition-colors">
            <ArrowLeft size={16} />
            Kembali
          </Link>
          <div className="flex items-center gap-2">
            <AppLogo size={28} />
            <span className="text-lg font-800 text-primary">Nongki</span>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center px-6 lg:px-12 xl:px-16 py-8">
          <div className="max-w-md w-full mx-auto">
            {/* Desktop back link */}
            <Link href="/" className="hidden lg:flex items-center gap-1.5 text-sm font-600 text-muted-foreground hover:text-primary transition-colors mb-8">
              <ArrowLeft size={15} />
              Kembali ke Beranda
            </Link>

            <div className="mb-8">
              <h1 className="text-2xl font-800 text-primary">
                {tab === 'login' ? 'Selamat datang kembali! 👋' : 'Gabung Nongki sekarang! ✨'}
              </h1>
              <p className="text-sm text-muted-foreground mt-2">
                {tab === 'login' ?'Masuk untuk lanjut jelajahi tempat nongkrong favoritmu.' :'Daftar gratis dan mulai eksplorasi Malang bareng komunitas.'}
              </p>
            </div>

            {/* Tab Toggle */}
            <div className="flex bg-secondary rounded-xl p-1 mb-8">
              <button
                onClick={() => setTab('login')}
                className={`flex-1 py-2.5 rounded-lg text-sm font-700 transition-all ${
                  tab === 'login' ? 'bg-card text-primary shadow-card' : 'text-muted-foreground hover:text-primary'
                }`}
              >
                Masuk
              </button>
              <button
                onClick={() => setTab('signup')}
                className={`flex-1 py-2.5 rounded-lg text-sm font-700 transition-all ${
                  tab === 'signup' ? 'bg-card text-primary shadow-card' : 'text-muted-foreground hover:text-primary'
                }`}
              >
                Daftar
              </button>
            </div>

            {tab === 'login' ? <LoginForm /> : <SignupForm />}
          </div>
        </div>
      </div>
    </div>
  );
}